import axios from 'axios';

// Gera, no SSO, o link de uso único para uma aplicação parceira (ex.: Heróis do ENEM).
// O código embutido na redirect_url expira em 5 minutos, por isso o link é gerado
// no clique, nunca ao carregar a página. Retorna { redirect_url, expires_at }.
export const createPartnerLink = async ({ ssoToken, clientId, state }) => {
  const sso = axios.create({ baseURL: process.env.REACT_APP_SSO_API_URL });

  const response = await sso.post('api/v1/partner/links', { client_id: clientId, client_origin: window.location.origin, state }, { headers: { Authorization: `Bearer ${ssoToken}` } });

  return response.data;
};
